export function validateEmailRegex(email) {
  /* eslint-disable max-len */
  const regexForEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  /* eslint-enable max-len */
  return regexForEmail.test(email);
}

export function validateUsernameRegex(username) {
  const specialCharExp = /[^a-zA-Z0-9]/;
  const usernameExp = /[a-zA-Z0-9]{3,}/;
  return username && usernameExp.test(username) && !specialCharExp.test(username);
}

const checker = {
  pwLength(pw) {
    return this.pwOk(pw) && pw.length >= 6;
  },
  pwNumber(pw) {
    return this.pwOk(pw) && (/[0-9]/).test(pw);
  },
  pwUppercase(pw) {
    return this.pwOk(pw) && (/[A-Z]/).test(pw);
  },
  pwLowercase(pw) {
    return this.pwOk(pw) && (/[a-z]/).test(pw);
  },
  pwLetter(pw) {
    return this.pwOk(pw) && (/[A-Za-z]/).test(pw);
  },
  pwSpecial(pw) {
    /* eslint-disable no-useless-escape */
    return this.pwOk(pw) && (/[~`!#@$%^&*+=\-\[\]\\';,/{}|.\\":<>?()_]/).test(pw);
    /* eslint-enable no-useless-escape */
  },
  pwOk(pw) {
    return pw && typeof pw === 'string';
  }
};


checker.passed = pw => checker.pwLength(pw) && checker.pwLetter(pw) && checker.pwNumber(pw);

// checker.passed = pw => checker.pwLength(pw) && checker.pwUppercase(pw)
//   && checker.pwLowercase(pw) && checker.pwNumber(pw) && checker.pwSpecial(pw);

checker.filters = [
  {
    func(pw) { return checker.pwLength(pw); },
    message: 'be more than 6 length'
  },
  // {
  //   func(pw) { return checker.pwUppercase(pw); },
  //   message: 'have a uppercase'
  // },
  // {
  //   func(pw) { return checker.pwLowercase(pw); },
  //   message: 'have a lowercase'
  // },
  {
    func(pw) { return checker.pwLetter(pw); },
    message: 'have a letter'
  },
  {
    func(pw) { return checker.pwNumber(pw); },
    message: 'have a number'
  }
  // {
  //   func(pw) { return checker.pwSpecial(pw); },
  //   message: 'have a special character'
  // }
];

export { checker };
